var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[_c('div',{attrs:{"id":"errorWrap"}},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("エラー")]),_c('hr'),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.defaultMsg))]),_c('div',{staticClass:"mt-3"},[_c('b-button',{on:{"click":_vm.back}},[_vm._v("戻る")])],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }